import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import gsap from 'gsap'

const MY_CONST = 2
const ENABLE_CONTROLS = false

class Scene {
  constructor({ rootEl, onHover, onSelect, onLoadComplete, onLoadProgress, hotspots }) {

    console.log('Scene construtor called.')

    this.canvas = document.createElement('canvas')

    this.onHoverCallback = onHover
    this.onSelectCallback = onSelect
    this.onLoadCompleteCallback = onLoadComplete
    this.onLoadProgressCallback = onLoadProgress

    this.hoverTarget = null

    this.root = rootEl
    this.width = rootEl.clientWidth
    this.height = rootEl.clientHeight

    this.hotspots = hotspots
    this.hotspotsDictionary = {}

    this.background = '#000000'

    this.box = null
    this.objects = []
    this.rocketParts = []

    this.isAddObjectMode = false

    this.displayConfig = {
      wireframe: false,
      rocket: true,
      displayMode: 1
    }

    this.isDev = false

    this.init()
    this.update()
    this.bindEvents()
  }

  updateDisplayConfig ( option ) {
    this.displayConfig = {
      wireframe: option.wireframe!=undefined?option.wireframe:this.displayConfig.wireframe,
      rocket: option.rocket!=undefined?option.rocket:this.displayConfig.rocket,
      displayMode: option.displayMode!=undefined?option.displayMode:this.displayConfig.displayMode,
    }
  }

  updateCameraTarget ( option ) {

    console.log('updateCameraTarget', option)

    if (option && option.target) {
      this.orbitControls.target.x = option.target.x
      this.orbitControls.target.y = option.target.y
      this.orbitControls.target.z = option.target.z
      console.log('option.target', option.target)
    }

    let hp = option&&option.hotspot>=0?option.hotspot:-1;
    console.log('option.hotspot', this.hotspotsDictionary, option.hotspot)

    if (hp>=0) {

      let hotspot = this.hotspotsDictionary[hp]

      // this.orbitControls.target.x = hotspot.x
      // this.orbitControls.target.y = hotspot.y
      // this.orbitControls.target.z = hotspot.z
      console.log('option.hotspot', hotspot)

      // this.orbitControls.autoRotate = false

      // this.orbitControls.autoRotateSpeed = 0

      let to = {
        angle: hotspot.angle,
        distance: hotspot.distance
      }

      console.log('to', to)

      gsap.killTweensOf(this.orbitControls)
      gsap.killTweensOf(this.orbitControls.target)

      if (hp==0) {
        this.orbitControls.autoRotateSpeed = 1
        gsap.to(this.orbitControls, {
          // maxAzimuthAngle: to.angle,
          // minAzimuthAngle: to.angle,
          minDistance: to.distance,
          maxDistance: to.distance,
          duration: 120,
          ease: 'none'
        })
        gsap.to(this.orbitControls.target, {
          x: hotspot.x,
          y: hotspot.y,
          z: hotspot.z,
          duration: 120,
          ease: 'none'
        })
      } else {
        this.orbitControls.autoRotateSpeed = 0
        gsap.to(this.orbitControls, {
          maxAzimuthAngle: to.angle,
          minAzimuthAngle: to.angle,
          minDistance: to.distance,
          maxDistance: to.distance,
          duration: 3,
          ease: 'power3.inOut'
        })

        gsap.to(this.orbitControls.target, {
          x: hotspot.x,
          y: hotspot.y,
          z: hotspot.z,
          duration: 2,
          ease: 'power3.inOut'
        })
      }

      for (let key in this.hotspotsDictionary) {
        this.hotspotsDictionary[key].dot.visible = false
      }
      if (hp==0||hp==13) {
        hotspot.dot.visible = false
      } else {
        hotspot.dot.visible = true
      }
    }
  }

  updateOrbitControls ( option ) {
    if (option.target.x) {
      this.orbitControls.target.x=option.target.x
    }
    if (option.target.y) {
      this.orbitControls.target.y=option.target.y
    }
    if (option.target.z) {
      this.orbitControls.target.z=option.target.z
    }
  }

  updateScene ( option ) {
    if (option.rotation.x) {
      this.scene.rotation.x=option.rotation.x
    }
    if (option.rotation.y) {
      this.scene.rotation.y=option.rotation.y
    }
    if (option.rotation.z) {
      this.scene.rotation.z=option.rotation.z
    }
  }

  updateCamera ( option ) {
    if (option.position.x) {
      this.camera.position.x=option.position.x
    }
    if (option.position.y) {
      this.camera.position.y=option.position.y
    }
    if (option.position.z) {
      this.camera.position.z=option.position.z
    }
  }

  updateOrbitControlsTarget (newTarget) {
    this.orbitControls.target.x=newTarget.x
    this.orbitControls.target.y=newTarget.y
    this.orbitControls.target.z=newTarget.z
  }

  triggerUpdate (options) {

    // dummy proof of concept
    // let buildingId = options && options.id || ''
    //
    // console.log('triggerUpdate', options)
    //
    // for (let i = 0; i < this.objects.length; i++) {
    //   let box = this.objects[i]
    //   if (buildingId && box.userData.building==buildingId) {
    //     box.material.color.setHex( 0xff0000 ); // make it red
    //     this.hoverTarget=box // set internal reference the box that matches ID
    //   } else {
    //     box.material.color.setHex( 0xffffff ); // make rest white
    //   }
    // }

    // dummy proof of concept
  }

  destroy() {
    if (this.scene) {
      this.scene.remove.apply(this.scene, this.scene.children);
    }
    if (this.scene2) {
      this.scene2.remove.apply(this.scene2, this.scene2.children);
    }
    if (this.canvas) {
      this.canvas.parentElement.removeChild(this.canvas)
    }
    if (this.raf) {
      cancelAnimationFrame(this.raf)
    }
    this.unbindEvents()
  }

  init() {
    this.initScene()
    this.initLights()
    this.initCamera()
    this.initRenderer()
    this.initOrbitControls()
    // this.initRaycaster()

    this.initModel()
    this.initEnvironment()
    this.initParticles()

    this.initStats()
    this.initHelpers()

    this.root.appendChild(this.canvas)
  }

  initStats () {

		this.stats = new Stats();
		this.stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
		window.document.body.appendChild( this.stats.dom );

    this.stats.dom.style.position='fixed'
    this.stats.dom.style.zIndex=999999999999
		this.stats.dom.style.left=0
		this.stats.dom.style.top='unset'
		this.stats.dom.style.right='unset'
		this.stats.dom.style.bottom=0
		// this.stats.dom.style.opacity=process.env.NODE_ENV!=='production'
    this.stats.dom.style.opacity=0

	}

  initScene() {
    this.scene = new THREE.Scene()
    // this.scene2 = new THREE.Scene()
    // this.scene.background = new THREE.Color(this.background)
  }

  initLights() {
    const hlights = new THREE.AmbientLight('#666666')
    const directionalLight = new THREE.DirectionalLight('#dfebff', 1)
    directionalLight.position.set(0, 10, 10)
    directionalLight.position.multiplyScalar(1.3)

    // this.scene.add(hlights)
    // this.scene.add(directionalLight)
  }

  initCamera() {
    const aspect = this.width / this.height

    this.camera = new THREE.PerspectiveCamera(3, aspect, 0.1, 1000)
    this.camera.position.set(-50, 5, -10)

    if (this.isDev) {
      this.camera = new THREE.PerspectiveCamera(30, aspect, 0.1, 1000)
      this.camera.position.set(0, 0, 50)
    }

    this.camera2 = new THREE.PerspectiveCamera(30, 1/3, 0.1, 1000)
    this.camera2.position.set(0, 0, 50)

    // this.camera = new THREE.PerspectiveCamera(10, aspect, 0.1, 100)
    // this.camera.position.set(0, 0, 10)
    // this.camera2 = new THREE.PerspectiveCamera(30, 1/3, 0.1, 100)
    // this.camera2.position.set(0, -10, 50)
  }

  initRenderer() {
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false })
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height)
    this.renderer.setClearColor(this.background, 1)

    this.renderer.toneMapping = THREE.ACESFilmicToneMapping
    this.renderer.toneMappingExposure = 1.8

    this.canvas = this.renderer.domElement
  }

  initOrbitControls() {


    if (this.isDev) {
      return
    }


    // this.orbitControls = new OrbitControls(this.camera2, this.canvas)
    this.orbitControls = new OrbitControls(this.camera, this.canvas)

    // this.orbitControls.maxPolarAngle = Math.PI * 0.45

    this.orbitControls.enableDamping = true
    this.orbitControls.dampingFactor = 0.05
    this.orbitControls.screenSpacePanning = false

    this.orbitControls.enableZoom = ENABLE_CONTROLS
    this.orbitControls.enablePan = ENABLE_CONTROLS
    this.orbitControls.enableRotate = ENABLE_CONTROLS

    this.orbitControls.autoRotate = true
    this.orbitControls.autoRotateSpeed = -0.5

    if (this.isDev) {
      this.orbitControls.autoRotate = false
      this.orbitControls.autoRotateSpeed = -0
    }

    this.orbitControls.maxAzimuthAngle = Math.PI*4
    this.orbitControls.minAzimuthAngle = -Math.PI*4

    this.orbitControls.maxDistance = 50
    this.orbitControls.minDistance = 50

    this.orbitControls.update()
  }

  initEnvironment () {

    const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
          pmremGenerator.compileEquirectangularShader();

    // const envTexture = '/textures/aircraft_workshop_bw.png'
    const envTexture = '/textures/matcaps/PushingPoints_Matcaps/Pmetal_003.png'

    new THREE.TextureLoader()
			.load(envTexture, (texture) => {
			const envMap = pmremGenerator.fromEquirectangular(texture).texture;
      envMap.encoding = THREE.sRGBEncoding;
			// set scene environment as the loaded envMap
			this.scene.environment = envMap;
      if (this.isDev) {
        // this.scene.environment=null
        // this.scene.background=null
      }
      // update the textureCube variable if you need to reuse it later on
      // this.textureCube = envMap
			texture.dispose();
    })
  }

  initParticles () {
    const vertices = [];

    for ( let i = 0; i < 5000; i ++ ) {

      const x = THREE.MathUtils.randFloatSpread( 50 );
      const y = THREE.MathUtils.randFloatSpread( 50 );
      const z = THREE.MathUtils.randFloatSpread( 50 );

      vertices.push( x, y, z );

    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );

    // const material = new THREE.PointsMaterial( { color: 0x888888 } );
    const material = new THREE.PointsMaterial( { size: 1, sizeAttenuation: false, alphaTest: 0.5, transparent: true } );

    const points = new THREE.Points( geometry, material );


    this.particles = points

    this.scene.add( this.particles );
  }

  initModel() {

    const wireframeMaterial = new THREE.MeshBasicMaterial({ wireframe: true, color: 0xFFFFFF, transparent: true, opacity: 0.1 });
    this.globalWireframeMaterial = wireframeMaterial
    this.wireframeGroup = new THREE.Group()
    // dummy geom for testing

    // const model = '/models/rocket_red-v2.glb'
    // const model = '/models/modelDraco.gltf'
    // const model = 'https://hato-public.s3.amazonaws.com/assets/gonogo/modelDraco.gltf'
    // const raycasterModel = '/models/NewFinalLayout-95-raycaster-model-draco.gltf'
    // const model = 'https://hato-public.s3.amazonaws.com/assets/gonogo/modelDraco2.gltf'
    const model = 'https://hato-public.s3.amazonaws.com/assets/gonogo/modelDraco3.gltf'
    // const model = 'https://hato-public.s3.amazonaws.com/assets/gonogo/model2.glb'
    const loader = new GLTFLoader()
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath( '/draco/' );
    loader.setDRACOLoader( dracoLoader );
    loader.load(model,
      (gltf) => {
        // gltf.scene.center();

        const mesh = gltf.scene

        const box = new THREE.Box3().setFromObject( mesh );
        this.box = box
        box.center( mesh.position ); // this re-sets the mesh position
        mesh.position.multiplyScalar( - 1 );

        mesh.traverse((child) => {
          if ( child.isMesh && child.geometry !== undefined ) {
            child.userData.originalMaterial = child.material.clone()
            // child.userData.wireframeMaterial = wireframeMaterial
            this.rocketParts.push(child)

            // const wireframe = new THREE.WireframeGeometry( child.geometry.clone() );
            // const line = new THREE.LineSegments( wireframe );
            // line.material.depthTest = false;
            // line.material.opacity = 0.5
            // line.material.linewidth = 0.1
            // line.material.transparent = true;
            // line.material.color = new THREE.Color(1,1,1)
            // this.wireframeGroup.add(line)

          }
        })

        this.scene.add(this.wireframeGroup);
        // const pivot = new THREE.Group();
        // this.scene.add( pivot );
        // pivot.add( meshToCentre );

        // mesh.translate(0,0,0)

        this.scene.add(mesh)
        // this.scene2.add(mesh.clone())
        //
        // this.initHelpers()

        this.onLoadCompleteCallback()

      },
      ( xhr ) => {
        let progress = ( xhr.loaded / xhr.total * 100 )
        // console.log( progress + '% loaded 1' );
        this.onLoadProgressCallback(progress)
      },
      ( error ) => {
        //
      });

    // let buildings=['A1','A2','A3','A4','B1','B2','B3','B4','C1','C2','C3','C4','D1','D2','D3','D4']
    // for (let i = 0; i < buildings.length; i++) {
    //   const geometry = new THREE.BoxGeometry( 0.4, 0.4, 0.4 );
    //   const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
    //   const cube = new THREE.Mesh( geometry, material );
    //   cube.position.x = i-buildings.length/2 + 0.5
    //   cube.userData.building=buildings[i]
    //   this.scene.add( cube );
    //   this.objects.push(cube)
    // }

    // dummy geom for testing
  }

  initHelpers () {
    const hotspots = this.hotspots
    // const box = this.box
    // const correction = {
    //   x: (box.max.x-box.min.x)/2,
    //   y: (box.max.y-box.min.y)/2,
    //   z: (box.max.z-box.min.z)/2
    // }

    // console.log('correction', correction)

    for (let key in hotspots) {

      let hotspot = hotspots[key]

      let anchor = hotspot.hotspotAnchor
      let distance = hotspot.hotspotDistance
      let angle = hotspot.hotspotAngle

      const sphere = new THREE.SphereGeometry(0.1);

      const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
      // object.position.x = anchor.x-(correction.x/4)
      // object.position.y = anchor.y-correction.y
      // object.position.z = anchor.z-correction.z
      object.position.x = anchor.x
      object.position.y = anchor.y
      object.position.z = anchor.z

      object.visible = false
      // const box = new THREE.BoxHelper( object, 0xffff00 );
      this.scene.add( object );

      // if (key=='4') {
      //   let newobject = object.clone()
      //   newobject.color = 0x00ff00
      //   newobject.position.x -= 0.5
      //   newobject.position.z -= 0.5
      //   newobject.visible = true
      //   this.scene.add( newobject );
      // }

      this.hotspotsDictionary[key] = {
        x: object.position.x,
        y: object.position.y,
        z: object.position.z,
        distance: distance,
        angle: angle,
        dot: object
      }

    }
  }

  initRaycaster() {
    this.raycaster = new THREE.Raycaster()
    this.mouse = new THREE.Vector2()
  }

  ray() {

    this.raycaster.setFromCamera(this.mouse, this.camera)
    const intersects = this.raycaster.intersectObjects([...this.objects], true)

    if (intersects.length > 0) {

      this.hoverTarget = intersects[0].object
      this.onHoverCallback(this.hoverTarget)

      for ( let i = 0; i < intersects.length; i ++ ) {
        if (intersects[ i ].object && intersects[ i ].object.material) {
          intersects[ i ].object.material.color.setHex( Math.random() * 0xffffff ); // set a random color so we know its constantly updating
        }
      }
    }
    // if (intersects.length > 0) {
    //   console.log(intersects[0].object.userData&&intersects[0].object.userData.building)
    // } else {
    //   //
    // }
  }

  render() {



    // this.camera.aspect = window.innerWidth / window.innerHeight;
		// this.camera.updateProjectionMatrix();
    let displayMode = this.displayConfig.displayMode

    // if (this.displayConfig.wireframe) {
    //
    //   this.particles.visible=false
    //   // this.wireframeGroup.visible=true
    //
    //   for (let iCamera2Parts = 0; iCamera2Parts < this.rocketParts.length; iCamera2Parts++) {
    //     this.rocketParts[iCamera2Parts].material = displayMode == 1 ? this.rocketParts[iCamera2Parts].userData.wireframeMaterial : this.rocketParts[iCamera2Parts].userData.originalMaterial
    //   }
    //
    //   let height2= this.width > 768 ? Math.floor(this.height*0.45) : Math.floor(this.height*0.25)
    //   let width2= Math.floor(height2/4);
    //   let left2= this.width > 768 ? Math.floor(this.width - 20 - width2) : Math.floor(this.width - 13 - width2);
    //   // let bottom2= Math.floor((this.height-height2)/2);
    //   // let bottom2= Math.floor((this.height - 20) - height2);
    //   let bottom2= this.width > 768 ? Math.floor(0) : Math.floor((this.height - 60) - height2);
    //
    //   this.renderer.setViewport( left2, bottom2, width2, height2 );
    //   this.renderer.setScissor( left2, bottom2, width2, height2 );
    //   this.renderer.setScissorTest( true );
    //   // this.renderer.render(this.scene2, this.camera2)
    //   this.renderer.render(this.scene, this.camera2)
    //   //
    //   // this.camera2.aspect = 1 / 5;
    //   // this.camera2.updateProjectionMatrix();
    //
    // }



    if (this.displayConfig.rocket) {

      this.particles.visible=true
      if (this.isDev) {
        this.particles.visible=false
      }
      // this.wireframeGroup.visible=false

      if (this.rocketParts && this.rocketParts[0] && this.rocketParts[0].material) {

        if (
          (displayMode == 1 && this.rocketParts[0].material.id != this.rocketParts[0].userData.originalMaterial.id)||
          (displayMode != 1 && this.rocketParts[0].material.id != this.globalWireframeMaterial.id)
        ) {

          for (let iCamera2Parts = 0; iCamera2Parts < this.rocketParts.length; iCamera2Parts++) {
            // this.rocketParts[iCamera2Parts].material = displayMode == 1 ? this.rocketParts[iCamera2Parts].userData.originalMaterial : this.rocketParts[iCamera2Parts].userData.wireframeMaterial
            this.rocketParts[iCamera2Parts].material = displayMode == 1 ? this.rocketParts[iCamera2Parts].userData.originalMaterial : this.globalWireframeMaterial
            // console.log(displayMode, iCamera2Parts)
          }

        }
      }

      // let left1= Math.floor(this.width * 0);
      // let bottom1= Math.floor(this.height * 0);
      // let width1= Math.floor(this.width * 1);
      // let height1= Math.floor(this.height * 1);
      // this.renderer.setViewport( left1, bottom1, width1, height1 );
      // this.renderer.setScissor( left1, bottom1, width1, height1 );
      // this.renderer.setScissorTest( true );

      // this.renderer.setClearColor( new THREE.Color( 0.5, 0.5, 0.7 ) );

      //
      // required to make orbit controls work
      //
      // this.camera.position.copy(this.camera2.position)
      //
      //
      //

      // this.camera.lookAt(this.scene.position)

      this.renderer.render(this.scene, this.camera)
      // this.renderer.autoClear = false

    }
  }

  update() {

    if (this.stats) {
			this.stats.begin();
		}

    this.raf = requestAnimationFrame(() => this.update())
    // this.ray()
    if (this.orbitControls) {
      this.orbitControls.update()
    }
    if (this.particles) {
      this.particles.rotation.y+=0.001
    }

    this.render()

    if (this.stats) {
			this.stats.end();
		}
  }

  // Callbacks

  onResize = () => {
    this.width = this.root.clientWidth
    this.height = this.root.clientHeight

    this.renderer.setSize(this.width, this.height)

    this.camera.aspect = this.width / this.height
    this.camera.updateProjectionMatrix()
  }

  onDocumentMouseMove = (event) => {
    event.preventDefault()
    let x=event.offsetX||event.clientX
    let y=event.offsetY||event.clientY
    this.mouse.x = (x / this.width) * 2 - 1
    this.mouse.y = -(y / this.height) * 2 + 1
  }

  onDocumentMouseDown = (event) => {
    // return
    event.preventDefault()
    if (this.hoverTarget) {
      this.onSelectCallback(this.hoverTarget)
    } else {
      this.onSelectCallback()
    }
  }

  bindEvents() {
    window.addEventListener('resize', this.onResize)
    // this.canvas.addEventListener('mousemove', this.onDocumentMouseMove, false)
    // this.canvas.addEventListener('mousedown', this.onDocumentMouseDown, false)
  }

  unbindEvents() {
    window.removeEventListener('resize', this.onResize)
    // this.canvas.removeEventListener('mousemove', this.onDocumentMouseMove, false)
    // this.canvas.removeEventListener('mousedown', this.onDocumentMouseDown, false)
  }
}

const SceneConstructor = (args) => new Scene(args)

export default SceneConstructor
